
import { connect } from 'react-redux';
import FreightChargeDetails from './FreightChargeDetails';
import { getFormValues, reset, destroy, isDirty, change } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
import { selectors as formSelectors } from 'ducks/form';

const FORM_NAME = 'ProductReceiptFreightDetails';
const mapStateToProps = (state: IApplicationState) => ({
    dirty: isDirty(FORM_NAME)(state),
    formValues: getFormValues(FORM_NAME)(state),
    formAsyncErrors: formSelectors.getFormAsyncErrors(FORM_NAME)(state),
});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        resetForm: () => reset(FORM_NAME),
        destoryForm: () => destroy(FORM_NAME),
        changeFormFieldValue: (fieldName: string, fieldValue: any) => change(FORM_NAME, fieldName, fieldValue),
    },
    dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(FreightChargeDetails);
